<template>
  <div class="px-12 lg:px-0 py-12 lg:py-16 border-t border-gray bg-white">
    <div class="lg:flex lg:items-center">
      <div class="flex lg:flex-none justify-center py-10">
        <pagination-progress :pagination="pagination" class="text-center lg:text-16 mb-12 lg:mb-0"/>
      </div>
      <div class="w-full flex justify-center py-10">
        <ul class="flex justify-between items-center px-10 lg:px-0 mx-auto text-black">
          <li
            class="uppercase mr-8 cursor-pointer flex items-baseline"
            @click="updatePage(1)"
            v-if="pagination.current_page !== 1"
            data-gtm-click="art-list.pagination.first"
            data-gtm-page="1">
            <i class="fas fa-angle-left lg:mr-6 text-32"></i>
            <!-- <span class="hidden lg:block">First</span> -->
          </li>
          <li
            class="uppercase mx-8 cursor-pointer flex items-baseline"
            @click="updatePage(pagination.current_page - 1)"
            v-if="pagination.links.previous"
            data-gtm-click="art-list.pagination.previous"
            :data-gtm-page="pagination.current_page - 1">
            <i class="fad fa-angle-double-left lg:mr-6 text-32"></i>
            <!-- <span class="hidden lg:block">Previous</span> -->
          </li>

          <!--  Page count      -->
          <li
            v-show="totalPage > 1"
            v-for="nth in totalPage"
            :key="nth"
            class="p-0 m-0 mx-10 cursor-pointer rounded-full w-30 h-30 relative lg:mx-6"
            :class="page(nth) === pagination.current_page ? 'bg-orange text-white' : 'bg-gray'"
            @click="updatePage(page(nth))"
            data-gtm-click="art-list.pagination.page"
            :data-gtm-page="page(nth)">
            <p class="text-14 center-absolute" style="font-family: sans-serif;">{{ page(nth) }}</p>
          </li>
          <!--  End page count      -->

          <li
            class="uppercase mx-8 cursor-pointer flex items-baseline"
            @click="updatePage(pagination.current_page + 1)"
            v-if="pagination.links.next"
            data-gtm-click="art-list.pagination.next"
            :data-gtm-page="pagination.current_page + 1">
            <!-- <span class="hidden lg:block">Next</span> -->
            <i class="fas fa-angle-right lg:ml-6 text-32"></i>
          </li>
          <li
            class="uppercase cursor-pointer flex items-baseline ml-8"
            @click="updatePage(pagination.total_pages)"
            v-if="pagination.total_pages !== pagination.current_page"
            data-gtm-click="art-list.pagination.last"
            :data-gtm-page="pagination.total_pages">
            <!-- <span class="hidden lg:block">Last</span> -->
            <i class="fad fa-angle-double-right lg:ml-6 text-32"></i>
          </li>
        </ul>
      </div>
      <!-- <div class="hidden lg:block">
        <pagination-progress :pagination="pagination" class="text-center lg:text-16 mb-12 lg:mb-0"/>
      </div> -->
    </div>
  </div>
</template>

<script>
import PaginationProgress from './PaginationProgress'

export default {
  components: {
    PaginationProgress,
  },

  inject: ['query'],

  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },

  methods: {
    page (nth) {
      return this.startPage + (nth - 1)
    },

    updatePage (page) {
      this.$nextTick(() => this.$emit('navigated', page))
      this.query.page = page
    },

    checkProceedingPagesExceedTotalPage (initStartPage) {
      return initStartPage + (this.totalPage - 1) > this.pagination.total_pages
    },
  },

  computed: {
    maxPagesVisible () {
      return this.$mq.lg ? 10 : 5
    },

    proceedingPages () {
      return this.$mq.lg ? 4 : 3
    },

    showProceedingPages () {
      return this.pagination.current_page + this.proceedingPages > this.totalPage &&
        this.pagination.current_page + this.proceedingPages <= this.pagination.total_pages
    },
    startPage () {
      //The starting number of page
      let initStartPage = Math.max(this.pagination.current_page - (this.totalPage - this.proceedingPages), 1)

      if (this.showProceedingPages) {
        initStartPage = (this.pagination.current_page + this.proceedingPages) - (this.totalPage - 1)
      }

      if (this.checkProceedingPagesExceedTotalPage(initStartPage)) {
        initStartPage = this.pagination.total_pages - (this.totalPage - 1)
      }

      return initStartPage
    },
    totalPage () {
      return Math.min(this.pagination.total_pages, this.maxPagesVisible)
    }
  }
}
</script>
